import { Style } from './style';
import theme from '../../../constants/theme';
export function SplashScreenComponent() {
    return (
        <div style={Style.container}>
            <img src={theme.ICONS.logoSplash} style={{height:208, width:286}} alt='bildir'/>
        </div>
    )
}